module.exports = __webpack_public_path__ + "static/media/Microsoft Lumia 950 White.95e59d9b.png";